/* Fade-in on scroll for the app showcase section.
   Tiny IntersectionObserver — no libraries. If the API is missing,
   the .no-observer class shows everything immediately.
   Guarded so it only initializes once even if the section is added
   to a page more than once (Shopify re-includes this asset's script
   tag per section instance). */
(function () {
  if (window.__acuvibesAppShowcaseInit) return;
  window.__acuvibesAppShowcaseInit = true;

  function init() {
    var targets = document.querySelectorAll('.app-showcase [data-reveal]');

    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.add('no-observer');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-scan when Shopify's theme editor injects/re-renders this section
     (e.g. after saving settings), so newly added instances also reveal. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.app-showcase')) init();
  });
})();
